import React from "react";
import { Text, OrientationBloc } from "../../../../components";
import {
  OrientationContainer,
  TitleContainer,
  SubTitleContainer,
} from "./styled-components";
import { getContactsList } from "../../../../helper/contacts";

const NegativeResponse = ({ contacts }: { contacts?: string }) => {
  const contactsList = getContactsList(contacts);

  return (
    <>
      <TitleContainer>
        <Text size="40px" weight={700} lineHeight="52px" align="center">
          Le Défenseur des droits ne semble <span>pas pouvoir vous aider.</span>
        </Text>
      </TitleContainer>
      <SubTitleContainer>
        <Text size="18px" align="center" color="grey400">
          D'autres personnes peuvent vous aider dans vos démarches.
        </Text>
      </SubTitleContainer>
      <OrientationContainer>
        <OrientationBloc options={contactsList} />
      </OrientationContainer>
    </>
  );
};

export default NegativeResponse;
